
const Easing = {
  Linear: (t) => t,

  InQuad: (t) => {
    return (t/=1)*t;
  },

  OutQuad: (t) => {
    return -1 *(t/=1)*(t-2);
  },

  InOutQuad: (t) => {
  if ((t/=0.5) < 1) return 0.5*t*t;
    return -0.5 * ((--t)*(t-2) - 1);
  },

  InCubic: (t) => {
    return (t/=1)*t*t;
  },

  OutCubic: (t) => {
    return ((t=t/1-1)*t*t + 1);
  },

  InOutCubic: (t) => {
  if ((t/=0.5) < 1) return 0.5*t*t*t;
    return 0.5*((t-=2)*t*t + 2);
  },

  InQuart: (t) => {
    return (t/=1)*t*t*t;
  },

  OutQuart: (t) => {
    return -1 * ((t=t/1-1)*t*t*t - 1);
  },

  InOutQuart: (t) => {
  if ((t/=0.5) < 1) return 0.5*t*t*t*t;
    return -0.5 * ((t-=2)*t*t*t - 2);
  },

  InQuint: (t) => {
    return (t/=1)*t*t*t*t;
  },

  OutQuint: (t) => {
    return ((t=t/1-1)*t*t*t*t + 1);
  },

  InOutQuint: (t) => {
    if ((t/=0.5) < 1) return 0.5*t*t*t*t*t;
    return 0.5*((t-=2)*t*t*t*t + 2);
  },

  InSine: (t) => {
    return -1 * Math.cos(t/1 * (Math.PI/2)) + 1;
  },

  OutSine: (t) => {
    return Math.sin(t/1 * (Math.PI/2));
  },

  InOutSine: (t) => {
    return -0.5 * (Math.cos(Math.PI*t/1) - 1);
  },

  // InExpo: (t) => {
  //   return (t==0) ? 0 : 1 * Math.pow(2, 10 * (t/1 - 1));
  // },

  OutExpo: (t) => {
    return (t==1) ? 2 : 1 * (-Math.pow(2, -10 * t/1) + 1);
  },

  InOutExpo: (t) => {
  if (t==0) return 0;
  if (t==1) return 1;
  if ((t/=0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
    return 0.5 * (-Math.pow(2, -10 * --t) + 2);
  },

  InCirc: (t) => {
    return -1 * (Math.sqrt(1 - (t/=1)*t) - 1);
  },

  OutCirc: (t) => {
    return Math.sqrt(1 - (t=t/1-1)*t);
  },

  InOutCirc: (t) => {
  if ((t/=0.5) < 1) return -0.5 * (Math.sqrt(1 - t*t) - 1);
    return 0.5 * (Math.sqrt(1 - (t-=2)*t) + 1);
  },
  InBack: (t) => {
  let s = 1.70158;
    return (t/=1)*t*((s+1)*t - s);
  },

  OutBack: (t) => {
  let s = 1.70158;
    return ((t=t/1-1)*t*((s+1)*t + s) + 1);
  },

  InOutBack: (t) => {
  let s = 1.70158;
  if ((t/=0.5) < 1) return 0.5*(t*t*(((s*=(1.525))+1)*t - s));
    return 0.5*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2);
  },

  InBounce: (t) => {
    return 1 - Easing.OutBounce (1-t);
  },

  OutBounce: (t) => {
  if ((t/=1) < (1/2.75)) {
    return 7.5625*t*t;
  } else if (t < (2/2.75)) {
    return 7.5625*(t-=(1.5/2.75))*t + .75;
  } else if (t < (2.5/2.75)) {
    return 7.5625*(t-=(2.25/2.75))*t + .9375;
  } else {
    return 7.5625*(t-=(2.625/2.75))*t + .984375;
    }
  },

  InOutBounce: (t) => {
    if (t < 0.5) return Easing.InBounce (t*2) * .5;
    return Easing.OutBounce (t*2-1) * 0.5 + 0.5;
  }
};

export default Easing;
